module.exports = require('../../full/instance/bind');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/features/instance/bind.js
// module id = 478
// module chunks = 0 1